export const staffleave = [
  {
    leaveType: "Medical Leave",
    leaveDate: "05 May 2024 - 09 May 2024",
    noOfDays: "5",
    appliedOn: "05 May 2024",
    status: "Approved",
  },
  {
    leaveType: "Casual Leave",
    leaveDate: "07 May 2024 - 07 May 2024",
    noOfDays: "1",
    appliedOn: "07 May 2024",
    status: "Approved",
  },
  {
    leaveType: "Special Leave",
    leaveDate: "09 May 2024 - 09 May 2024",
    noOfDays: "1",
    appliedOn: "09 May 2024",
    status: "Pending",
  },
  {
    leaveType: "Casual Leave",
    leaveDate: "08 May 2024 - 08 May 2024",
    noOfDays: "1",
    appliedOn: "04 May 2024",
    status: "Approved",
  },
  {
    leaveType: "Medical Leave",
    leaveDate: "08 May 2024 - 11 May 2024",
    noOfDays: "4",
    appliedOn: "08 May 2024",
    status: "Pending",
  },
  {
    leaveType: "Casual Leave",
    leaveDate: "20 May 2024 - 20 May 2024",
    noOfDays: "1",
    appliedOn: "19 May 2024",
    status: "Pending",
  },
];
